module.exports = __webpack_public_path__ + "img/unity-environment.300aae32.png";